module.exports = __webpack_public_path__ + "img/germany-pneumonia-female.258dc96c.png";